<a class="error-icon-link" *ngIf="errors && errors.length > 0" (click)="showErrors()">
    <span class="content">{{errors.length}}</span>
</a>